import PropTypes from 'prop-types';
import React from 'react';
import { map } from 'lodash';
import { useNewCapability } from 'sharedHooks';

import { Row } from 'react-bootstrap';
import ParameterSection from './Sections/ParameterSection';
import './style.scss';


const TrendKPIListComponent = (props) => {
    const { model, actions } = props; // COMMENTED ACTIONS FOR REMOVE WARNINGS
    const capability = useNewCapability();

    const sectionKpi = [{ data: model?.trendKPIsList }];

    return (
        <div className='signal-block'>
            {model?.trendKPIsList?.length ?
                <Row className='trend-kpi-list measurement-list-container'>
                    {
                        map(sectionKpi, (kpiSection, kpiIndex) => {
                            return <ParameterSection
                                key={kpiIndex}
                                section={kpiSection}
                                capability={capability}
                                dateSelection={model?.dateSelection}
                                selectedTrendsData={model?.selectedTrendsData}
                                selectedTrendKPIs={model?.selectedTrendKPIs}
                                setShowLimitSetting={actions?.setShowLimitSetting}
                                selectedNotification={model?.selectedNotification}
                                limitFromSummary={model?.limitFromSummary}
                                setClickedConfigKpi={actions?.setClickedConfigKpi} />;
                        })
                    }
                </Row> : null}
        </div>
    );
};

TrendKPIListComponent.propTypes = {
    actions: PropTypes.shape({
        getTrendKPIsForAssetV2: PropTypes.func,
        setShowLimitSetting: PropTypes.func,
        setClickedConfigKpi: PropTypes.func,
    }),
    model: PropTypes.shape({
        trendKPIsList: PropTypes.array,
        selectedTrendKPIs: PropTypes.array,
        dateSelection: PropTypes.object,
        selectedTrendsData: PropTypes.array,
        selectedNotification: PropTypes.object,
        limitFromSummary: PropTypes.string
    })
};

export default TrendKPIListComponent;
